import {Component, Injector, OnInit} from '@angular/core';
import {BaseFormComponentComponent} from '../../../shared/base-form-component/base-form-component.component';
import {SimpleEntity} from '../../../models/simple-entity.model';
import {WhForwardingModel} from '../../../models/loads/wh-forwarding.model';
import {LoadsService} from '../../../services/loads/loads.service';
import {WhForwardingPackEditModel} from '../../../models/loads/wh-forwarding-pack-edit.model';
import {WhStockModel} from '../../../models/loads/wh-stock.model';

@Component({
  selector: 'app-pending-request-list',
  templateUrl: './pending-request-list.component.html',
  styleUrls: ['./pending-request-list.component.scss']
})
export class PendingRequestListComponent extends BaseFormComponentComponent implements OnInit {

    imageDisplay: boolean = false;
    photoData: string = null;
    whForwardings: SimpleEntity[] = [];
    whForwarding: WhForwardingModel = null;
    status = 'PENDING';



    constructor(protected injector: Injector, private loadService: LoadsService) {
        super(injector);
    }

    async ngOnInit() {
        this.whForwardings = await this.loadService.getWhForwardings(this.status).toPromise();
        console.log(this.whForwardings, "forwardings");

    }

    async getWhForwarding(whForwarding: WhForwardingModel) {
        this.whForwarding = await this.loadService.getWhForwarding(whForwarding.id).toPromise();
    }

    async save() {
        try {
            this.isLoading = true;
            await  this.loadService.createOrUpdateWhForwarding(this.whForwarding).toPromise();
            this.isLoading = false;
            this.showMessage('success', '', 'Kayıt başarılı.')
        } catch  {
            this.isLoading = false;
        }

    }

    async setStatusWhForwarding(whForwarding: any, statusType: string) {
        let index = this.whForwardings.indexOf(whForwarding);
        whForwarding.statusType = statusType;
        try {
            this.isLoading = true;
            await  this.loadService.setStatusWhForwarding(whForwarding).toPromise();
            this.whForwardings.splice(index, 1);
            this.isLoading = false;
            this.whForwarding = null;
            this.showMessage('success', '', 'Durum atandı : ' + statusType);
        } catch  {
            this.isLoading = false;
        }
    }


    showDialog(photoData) {
        if (photoData) {
            this.photoData = photoData;
            this.imageDisplay = true;
        }
    }

    getTotalStockByStocks(mainStock: WhStockModel) {
        if (mainStock.stocks) {
            let totalStock = 0;
            mainStock.stocks.forEach(stock => {
                totalStock += stock.stock;
            });
            return totalStock;
        }
        return mainStock.stock;
    }
}
